"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBrokenVideo = exports.createTranscodingReadyVideo = exports.createLiveProcessedVideo = exports.createTranscodingVideo = exports.createFinalizedVideo = exports.createLiveVideo = exports.createScheduledVideo = exports.createCustomizedVideo = exports.createVideo = void 0;
var tslib_1 = require("tslib");
var api_types_1 = require("@wix/wix-vod-constants/api-types");
var common_1 = require("@wix/wix-vod-constants/common");
var chance_1 = require("../chance");
var _media_info_1 = require("./_media-info");
var _deal_info_1 = require("./_deal-info");
var chance = (0, chance_1.getChance)();
var createVideo = function () { return ({
    allowDownload: false,
    cast: [],
    categories: chance.n(chance.word, 5),
    coverUrl: chance.url({ extensions: ['jpg'] }),
    createdTs: chance.date(),
    crew: [],
    customCoverUrl: null,
    datePublish: chance.date().toDateString(),
    dealInfo: [
        tslib_1.__assign(tslib_1.__assign({}, (0, _deal_info_1.createDealInfo)(common_1.DEAL_INFO_TYPES.RENT)), { period: chance.natural() }),
        tslib_1.__assign(tslib_1.__assign({}, (0, _deal_info_1.createDealInfo)(common_1.DEAL_INFO_TYPES.SALE)), { 
            // should we not have period for sale?
            period: -1 }),
    ],
    description: null,
    durationSec: 23,
    durationStr: "".concat(chance.minute()).concat(chance.second()),
    id: chance.hash(),
    listId: chance.hash(),
    listOrder: chance.natural(),
    mediaExternUrl: null,
    mediaFileName: chance.hash(),
    mediaInfo: (0, _media_info_1.createVideoMediaInfo)(),
    mediaType: 'secure_video',
    memberOnly: false,
    ownerId: chance.hash(),
    publishChanges: true,
    state: null,
    tags: chance.n(chance.word, 5),
    title: chance.word(),
    trailerInfo: null,
    trailerTranscodingStatus: 'NONE',
    transcodingStatus: 'READY',
    updatedTs: chance.date(),
    usedInLists: [],
    videoSource: common_1.VIDEO_SOURCES.COMPUTER,
    itemId: chance.guid(),
    itemType: api_types_1.ItemType.Item,
    contentUrl: chance.url(),
    hasCards: false,
    embedOptions: {
        enabled: false,
        showInfo: false,
        showShare: false,
        showTitle: false,
        showLogo: false,
        logoVisibility: null,
    },
    previewType: common_1.PREVIEW_TYPES.FIRST_20_SEC,
}); };
exports.createVideo = createVideo;
function createCustomizedVideo(videoProps) {
    return tslib_1.__assign(tslib_1.__assign({}, (0, exports.createVideo)()), videoProps);
}
exports.createCustomizedVideo = createCustomizedVideo;
function createScheduledVideo() {
    return createCustomizedVideo({
        previewType: common_1.PREVIEW_TYPES.NONE,
        itemType: api_types_1.ItemType.ItemScheduled,
        videoSource: common_1.VIDEO_SOURCES.LIVE,
    });
}
exports.createScheduledVideo = createScheduledVideo;
function createLiveVideo() {
    return createCustomizedVideo({
        previewType: common_1.PREVIEW_TYPES.NONE,
        itemType: api_types_1.ItemType.ItemLive,
        videoSource: common_1.VIDEO_SOURCES.LIVE,
    });
}
exports.createLiveVideo = createLiveVideo;
function createFinalizedVideo() {
    return createCustomizedVideo({
        previewType: common_1.PREVIEW_TYPES.NONE,
        itemType: api_types_1.ItemType.ItemLiveFinalize,
        videoSource: common_1.VIDEO_SOURCES.LIVE,
    });
}
exports.createFinalizedVideo = createFinalizedVideo;
function createTranscodingVideo(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.transcodingStatus, transcodingStatus = _c === void 0 ? common_1.TRANSCODING_STATUSES.INPROGRESS : _c;
    return createCustomizedVideo({
        previewType: common_1.PREVIEW_TYPES.NONE,
        itemType: 'item',
        transcodingStatus: transcodingStatus,
    });
}
exports.createTranscodingVideo = createTranscodingVideo;
function createLiveProcessedVideo() {
    return createCustomizedVideo({
        itemType: 'item',
        videoSource: common_1.VIDEO_SOURCES.LIVE,
    });
}
exports.createLiveProcessedVideo = createLiveProcessedVideo;
function createTranscodingReadyVideo() {
    return createTranscodingVideo({
        transcodingStatus: common_1.TRANSCODING_STATUSES.READY,
    });
}
exports.createTranscodingReadyVideo = createTranscodingReadyVideo;
var createBrokenVideo = function () {
    return createCustomizedVideo({
        itemType: undefined,
    });
};
exports.createBrokenVideo = createBrokenVideo;
//# sourceMappingURL=video.js.map